import { IProjectResourceCalculationsAssignment } from '../../interfaces/iproject-resource-calculations-assignment';
import { Project } from '../project';
import { ResourceCategory } from '../resource-category';

export class ProjectResourceCalculationsAssignmentBase {
  ProjectResourceCalculationsAssignmentId: number;
  ProjectId: number | null;
  ResourceCategoryId: number | null;
  Calculation: string | null;
  IsSynced: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Project?: Project;
  ResourceCategory?: ResourceCategory;

  constructor(item?: IProjectResourceCalculationsAssignment) {
    if (item) {

      this.ProjectResourceCalculationsAssignmentId = item.ProjectResourceCalculationsAssignmentId;
      this.ProjectId = item.ProjectId;
      this.ResourceCategoryId = item.ResourceCategoryId;
      this.Calculation = item.Calculation;
      this.IsSynced = item.IsSynced;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Project = new Project(item.Project);
      this.ResourceCategory = new ResourceCategory(item.ResourceCategory);
    }
  }
}